import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Background decorative elements */}
      <div className="bg-decoration"></div>
      <div className="bg-decoration"></div>
      <div className="bg-decoration"></div>

      {/* Header with Login button */}
      <header className="landing-header">
        <button 
          onClick={() => navigate('/login')} 
          className="login-button"
        >
          Login
        </button>
      </header>

      {/* Main content */}
      <main className="landing-main">
        <div className="logo-container">
          <h1 className="logo">LUMESA</h1>
          <p className="subtitle">TRAVEL</p>
        </div>
        
        <h2 className="coming-soon">Coming Soon</h2>
        
        <p className="description">
          Your journey to extraordinary travel experiences begins here. 
          We're crafting something special just for you.
        </p>
      </main>

      {/* Footer */}
      <footer className="landing-footer">
        <p>&copy; 2025 LUMESA TRAVEL. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LandingPage;

